export const HEALTH_SYSTEM = 'healthSystem';
export const CLINIC = 'clinic';
export const PROVIDER_RESOURCE = 'providerResource';
export const CALENDAR = 'calendar';
